let disasters = [];

export default {
  disasters: disasters,
  reset: function () {
    disasters.splice(0)
  },
  fire: {
    set: function (target, power, growth) {
      disasters.push({type: 'fire', target, power, growth, trend: 0, elapse: 0, input: 0})
    },
    get: function (target) {
      let fire = disasters.find(function (fire) {
        return fire.target === target
      });
      return fire || {type: 'fire',target, power: 0, growth: 0}
    }
  }
}
